export class Helper {
    /**
     * Creates a unique guid
     * @returns A guid
     */
    public static guid = (): string => {
        return Helper.s4() + Helper.s4() + '-' + Helper.s4() + '-' + Helper.s4() + '-' +
            Helper.s4() + '-' + Helper.s4() + Helper.s4() + Helper.s4();
    };

    /**
     * Generates a random string
     * @returns A random string
     */
    private static s4(): string {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
}

/**
 * deleteCookie
 *
 * helper to delete cookie with give name and value for domain
 *
 * @param name
 * @param value
 * @param days
 * @param domain
 */
export function setCookie(name: string, value: string, days: number, domain: string = null) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/" +
        ((domain) ? ";domain=" + domain : "");
}

/**
 * deleteCookie
 *
 * helper to delete cookie with give name and value for domain
 *
 * @param name
 * @param path
 * @param domain
 */
export function deleteCookie(name: string, path: string = null, domain: string = null) {
    document.cookie = name + "=" +
        ((path) ? ";path=" + path : "") +
        ((domain) ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
/**
 * getCookie
 *
 * helper to return cokie value by name
 *
 * @param name
 */
export function getCookie(name: string) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
    else return '';
}

/**
 * getToken
 *
 * helper to return fake token if session storage is empty
 *
 * @param name
 */
export function getToken(name: string) {
    let token: string;
    if (token = localStorage.getItem(name)) {
        return token;
    } else {
        // return fake token to force app to logout user
        return '';//'eyJhbGciOiJub25lIiwidHlwIjoiSldUIn0.eyJpc3MiOiJodHRwczovL2p3dC1pZHAuZXhhbXBsZS5jb20iLCJzdWIiOiJtYWlsdG86bWlrZUBleGFtcGxlLmNvbSIsIm5iZiI6MTUzMzcwOTI1NiwiZXhwIjoxNTMzNzEyODU2LCJpYXQiOjE1MzM3MDkyNTYsImp0aSI6ImlkMTIzNDU2IiwidHlwIjoiaHR0cHM6Ly9leGFtcGxlLmNvbS9yZWdpc3RlciJ9.';
    }
}
